import * as React     from "react"
import PropTypes      from "prop-types"
import _              from "lodash"
import ChartComponent from "react-chartjs-2"
import { Bar, Pie }   from "react-chartjs-2"
import { injectIntl } from "react-intl"
import RatiosTable    from "../ratios-table"
import ModalChart     from "../modal-chart"
import ExportTable     from "../export-table"

export const CHART_SECTIONS = {
	CHARGES : "CHART_SECTIONS.CHARGES",
	PRODUCTS: "CHART_SECTIONS.PRODUCTS"
}

class SituationComponent extends React.Component {
	constructor(props) {
		super(props)

		this.defaultTitleOptions = { display: true}

		this.pieChartOptions = {
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]
					const total          = _.sum(data.datasets[datasetIndex].data)
					const percentage     = total ? _.round(value * 100 / total) : 0
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${data.labels[dataIndex]} : ${formattedValue} (${percentage}%)`
				}
			}}
		}

		this.defaultBarChartOptions = {
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						callback: (value, index, values) => (
						this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					)}
				},
				{
					gridLines: { display: false },
					id       : "inhabitants",
					position : "right",
					ticks    : { callback: (value, index, values) => (this.props.intl.formatNumber(value)) }
				}
			]},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]

					if (data.datasets.length === datasetIndex - 1) {
						const total          = _.sum(data.datasets[datasetIndex].data)
						const percentage     = total ? _.round(value * 100 / total) : 0
						const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
						return `${data.datasets[datasetIndex].label} : ${formattedValue} (${percentage}%)`
					} else {
						const formattedValue = this.props.intl.formatNumber(value)
						return `${data.datasets[datasetIndex].label} : ${formattedValue}`
					}
				}
			}}
		}

		this.perInhabitantChartOptions = {
			...this.defaultBarChartOptions
		}

		this.modalTabs = [
			{ id: CHART_SECTIONS.PRODUCTS, label: "Produits réels" },
			{ id: CHART_SECTIONS.CHARGES,  label: "Charges réelles" }
		]
	}

	render() {
		const chartTitles   = this.props.chartTitles
		const loading       = this.props.loading
		const displayCharts = this.props.displayCharts
		return (
			<div style={{ height: "100%", overflow: "auto", width: "100%" }}>
				{!loading && <button className="button is-text" onClick={this.props.onClickShowCharts}>Afficher les graphiques</button>}
				<ExportTable data={this.props.tableData} slug={this.props.slug} id={this.props.id} years={this.props.years} />

				<RatiosTable data={this.props.tableData} years={this.props.years} />

				{displayCharts && (
					<ModalChart
					displayCharts        = {displayCharts}
					onClickChartModalTab = {this.props.onClickChartModalTab}
					onClickHideCharts    = {this.props.onClickHideCharts}
					onClickShowCharts    = {this.props.onClickShowCharts}
					title                = "Situation financière de fonctionnement"
					tabs                 = {this.modalTabs}>
						<Pie data={this.props.pieChartData} options={{...this.pieChartOptions, title: { display: true, text: chartTitles.pie }}} />
						<Bar data={this.props.totalChartData} options={{...this.defaultBarChartOptions, title: { display: true, text: chartTitles.barTotal }}} />
						<Bar data={this.props.perInhabitantChartData} options={{...this.perInhabitantChartOptions, title: { display: true, text: chartTitles.barPerInhabitant } }} />
					</ModalChart>
				)}
			</div>
		)
	}
}

export default injectIntl(SituationComponent)

SituationComponent.propTypes = {
	displayCharts         : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.oneOf([CHART_SECTIONS.CHARGES, CHART_SECTIONS.PRODUCTS])
	]).isRequired,
	chartTitles           : PropTypes.shape({
		pie             : PropTypes.string,
		barTotal        : PropTypes.string,
		barPerInhabitant: PropTypes.string
	}).isRequired,
	loading               : PropTypes.bool.isRequired,
	onClickChartModalTab  : PropTypes.func.isRequired,
	onClickHideCharts     : PropTypes.func.isRequired,
	onClickShowCharts     : PropTypes.func.isRequired,
	perInhabitantChartData: ChartComponent.propTypes.data,
	pieChartData          : ChartComponent.propTypes.data,
	tableData             : PropTypes.array.isRequired,
	totalChartData        : ChartComponent.propTypes.data,
	years                 : PropTypes.arrayOf(PropTypes.number).isRequired
}


// WEBPACK FOOTER //
// ./src/component/ratios/situation/situation-component.js